$('.tego-addchild').click(function () {

    $action = $(this).attr('action');

    $.ajax({
        url: $action,
        type: 'GET',
        success: function (data) {
            $('.modal-body-add-child-aet').html(data);
            $('.modal-aet-add-child').showTegoModal();
            $('.modal-aet-add-child').find('.tego-dateagpm').dateagpm();
        },
        error: function (xhr, textStatus, errorThrown) {
            console.error('erreur', textStatus);
        }
    });
})

$('.valid-etap1 .app-button').click(function () {
    const checks = $(this).closest('form').find("input[name^='selectionEnfant']:checked")
    if (checks.length === 0) {
        $('.errorSelection').removeClass('d-none')
        return false
    }
})

$("input[name^='selectionEnfant']").change(function () {
    if ($(this).prop('checked') && !$('.errorSelection').hasClass('d-none')) {
        $('.errorSelection').addClass('d-none')
    }
})

$(document).on('click', '.modal-body-add-child-aet .app-button', function(){
    validationFormEnfantModal();
})

function validationFormEnfantModal() {
    $('.modal-body-add-child-aet-error').css('display', 'none');
    let erreur = "";
    let erreurCivilite = estCivilite("civilite");
    let erreurCiviliteNom = estNomPrenom("nom");
    let erreurCivilitePrenom = estNomPrenom("prenom");
    let erreurDate = estDate("dateNaissance", 28, false);

    if(erreurCivilite != "") erreur += "<li>"+erreurCivilite+"</li>";
    if(erreurCiviliteNom != "") erreur += "<li>"+erreurCiviliteNom+"</li>";
    if(erreurCivilitePrenom != "") erreur += "<li>"+erreurCivilitePrenom+"</li>";
    if(erreurDate != "") erreur += "<li>"+erreurDate+"</li>";
    if (erreur != "") {
        $('#modal-body-add-child-aet-error-message').html(erreur);
        $('.modal-body-add-child-aet-error').css('display', 'block');
        return false
    } else $('#formEnfantModal').submit();
}

function estCivilite(nomChamp) {
    const champAVerifier = $("input[name='" + nomChamp + "']:checked").val();
    if (!champAVerifier) return 'Le champ <strong>"civilité"</strong> est obligatoire.';
    return "";
}

function estNomPrenom(nomChamp) {
    const champAVerifier = $("input[name^='" + nomChamp + "']").val().trim();
    const champAVerifierErrorVide = $("input[name^='" + nomChamp + "']").attr("msgErrorVide");
    const champAVerifierError = $("input[name^='" + nomChamp + "']").attr("msgError");
    let pattern = /^([a-zA-ZéèêëçàâäáîïìíùûüúñôóòöõÉÈÊËÇÀÂÄÁÎÏÌÍÙÔÓÒÖÛÕÜÚÑ '-])+$/;
    let result = pattern.test(champAVerifier);

    if (!champAVerifier) return champAVerifierErrorVide
    if (!result) return champAVerifierError
    return "";
}

function estDate(nomChamp, age=-1, futur=false) {
    const champAVerifier = $("input[name^='" + nomChamp + "']").val().trim();
    const champAVerifierErrorVide = $("input[name^='" + nomChamp + "']").attr("msgErrorVide");
    const champAVerifierErrorAge = $("input[name^='" + nomChamp + "']").attr("msgErrorAge");
    const champAVerifierError = $("input[name^='" + nomChamp + "']").attr("msgError");
    const champAVerifierErrorFormat = $("input[name^='" + nomChamp + "']").attr("msgErrorFormat");

    if (!champAVerifier) return champAVerifierErrorVide
    else {
        const formattedDate = new Date(champAVerifier)
        const y = formattedDate.getFullYear();
        var dateJour = new Date();
        var dateJourY = dateJour.getFullYear();
        const ageCalcul = dateJourY - y;
        if (('' + y).length !== 4) return champAVerifierErrorFormat;
        if (age != "-1" && ageCalcul >= age) return champAVerifierErrorAge;
        if(!futur) {
            if(formattedDate.getTime()>dateJour.getTime()) return champAVerifierError
        }
    }
    return "";
}
